import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import * as ROUTES from '../constants/routes';
import { toggleModal } from '../reducers/modalReducer';
import { postRequest, showMessage } from '../config';
import { Link } from 'react-router-dom';
import AnimatedPage from '../components/AnimatedPage';

const IconMail = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" /><polyline points="22,6 12,12 2,6" /></svg>;

const ForgotPassword = () => {
    const dispatch = useDispatch();
    const [forgotPasswordEmail, setForgotPasswordEmail] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const resetStates = () => {
        setForgotPasswordEmail('');
        setIsLoading(false);
    };

    const handleResetPassword = async () => {
        if (!forgotPasswordEmail || forgotPasswordEmail == '') return showMessage('Please provide email');

        setIsLoading(true);

        let response = await postRequest('/user/forgotPassword', { email: forgotPasswordEmail });
        if (response && response['code'] == 200) {
            resetStates();
            dispatch(toggleModal({ open: "resendForgotPasswordEmail", historyData: { email: forgotPasswordEmail } }))
            showMessage(response['message']);
        }

        setIsLoading(false);
    };


    return (
        <AnimatedPage>
            <div className="lp-page">
                <div className="lp-auth-main">
                    <div className="lp-auth-glow lp-auth-glow--tr" aria-hidden="true" />
                    <div className="lp-auth-glow lp-auth-glow--bl" aria-hidden="true" />

                    <div className="lp-auth-wrap lp-auth-wrap--narrow">
                        <div className="lp-auth-card">
                            <h1 className="lp-auth-title">Forgotten</h1>
                            <h1 className="lp-auth-title pink">password?</h1>
                            <p className="lp-auth-desc">Enter the email address linked to your account and we'll send you a link to reset your password.</p>

                            <div className="lp-auth-field lp-auth-field--icon-wide">
                                <span className="icon"><IconMail /></span>
                                <input
                                    id='forgotPasswordEmail'
                                    type='email'
                                    value={forgotPasswordEmail || ''}
                                    placeholder='Email'
                                    onChange={(e) => setForgotPasswordEmail(e['target']['value'])}
                                />
                            </div>

                            <div className="lp-auth-actions">
                                <button
                                    className="lp-auth-submit"
                                    onClick={() => handleResetPassword()}
                                >
                                    {isLoading ? <i className="fa fa-spinner fa-spin"></i> : 'Reset Password'}
                                </button>
                            </div>

                            <p className="lp-auth-foot">
                                Don't have an account? <Link to={ROUTES.REGISTER}>Create new account</Link>
                            </p>
                        </div>

                        <p className="lp-auth-trust">Trusted by 50+ investors, advisors &amp; companies</p>
                    </div>
                </div>
            </div>
        </AnimatedPage>
    )
}

export default ForgotPassword
